import { formValueSelector as rfFormValueSelector } from 'redux-form';
import { createSelector } from 'reselect';
import moment from 'moment';

import { APPLIED_MENU_CONFIG_FORM_NAME } from 'Common/FormEnum';
import { EditAppliedMenuConfigFieldEnum as EditConfigFields } from 'Common/FieldEnum';

const formValueSelector = rfFormValueSelector(APPLIED_MENU_CONFIG_FORM_NAME);

export const getFormStartDate = state =>
  formValueSelector(state, EditConfigFields.StartDate);

export const getFormEndDate = state =>
  formValueSelector(state, EditConfigFields.EndDate);

export const getStartDate = createSelector(getFormStartDate, formStartDate => {
  const date = moment(formStartDate);

  return date.isValid() ? date.toDate() : null;
});

export const getEndDate = createSelector(getFormEndDate, formEndDate => {
  const date = moment(formEndDate);

  return date.isValid() ? date.toDate() : null;
});



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/editappliedmenuconfig/selectors.js